import { VStack } from "native-base";
import React from "react";

import FormButton from "@/components/atoms/FormButton";
import Modal from "@/components/molecules/Modal";
import { useAppNavigation } from "@/hooks/application/navigation";
import { AuthNavigation } from "@/navigation/stacks/AuthenticationStack";

type ComponentProps = {
  modalVisible: boolean;
  onClose: () => void;
};

const SignupBySegmentModal = ({ modalVisible, onClose }: ComponentProps) => {
  const { navigate } = useAppNavigation<AuthNavigation>();

  const goToSignup = (type: "company" | "customer") => {
    onClose();
    navigate(type === "company" ? "signupCompany" : "signupCustomer");
  };

  return (
    <Modal
      isOpen={modalVisible}
      onClose={onClose}
      Header="Qual o seu segmento?"
      Body={
        <VStack w="full">
          <FormButton w="full" mb={22} onPress={() => goToSignup("company")}>
            Sou Cliente Empresa
          </FormButton>
          <FormButton
            w="full"
            mb={22}
            colorScheme="white"
            textColor="primary.700"
            onPress={() => goToSignup("customer")}>
            Sou Cliente Pessoa Física
          </FormButton>
        </VStack>
      }
    />
  );
};

export default SignupBySegmentModal;
